declare var $: any;

// Pass a zone to read the clock in it. Left out, the clock keeps formatting in
// the browser's zone, which is what every page using this control did before and
// still does unless it opts in.
class LiveClock {
  timeZone?: string;

  constructor(timeZone?: string) {
    this.timeZone = timeZone && timeZone.length > 0 ? timeZone : undefined;
    setInterval(() => this.updateClock(), 1000);
  }

  updateClock() {
    const timeOptions: Intl.DateTimeFormatOptions = {
      hour: 'numeric', minute: 'numeric', second: 'numeric',
    };
    const dateOptions: Intl.DateTimeFormatOptions = {
      month: 'long', weekday: 'short', day: 'numeric',
    };

    if (this.timeZone) {
      timeOptions.timeZone = this.timeZone;
      dateOptions.timeZone = this.timeZone;
    }

    const timeFormatter = new Intl.DateTimeFormat([], timeOptions);

    const dateFormatter = new Intl.DateTimeFormat(['en-US'], dateOptions);

    $('#live_time').html(timeFormatter.format(new Date()));
    $('#live_date').html(`${dateFormatter.format(new Date())}th`);
  }
}

export default LiveClock;
